import type {
    ClassicalAPIResponse,
    ClassicalListViewPage,
} from '@jet-app/music-classical/api/types';
import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import type { Page } from '@jet-app/music-classical/models';
import type { ObjectGraph } from '@jet/environment/dependencies';

export function renderEmptyPage<T extends Page>(
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    objectGraph: ObjectGraph,
): T {
    const responseBody = apiResponse?.body as ClassicalListViewPage;
    return {
        pageKind: 'emptyScreen',
        sections: [
            {
                heading: responseBody.firstPage.heading,
                description: responseBody.firstPage.description,
                icon: responseBody.firstPage.icon,
            },
        ],
        canonicalURL,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.libraryListPage,
        ),
    } as T;
}

export function isEmptyPage(apiResponse: ClassicalAPIResponse): boolean {
    const responseBody = apiResponse?.body as ClassicalListViewPage;
    return responseBody.firstPage.type === 'empty' ? true : false;
}
